/* 
    Constants for testing purposes (so tests don't break when a small name is changed)
*/

export const CONTRACT_SECTION_NAME = 'Edit Contract';
export const INVOICE_SECTION_NAME = 'Invoice Data';
export const SERVICE_CALL_SECTION_NAME = 'serviceCalls';
export const SERVICE_CALL_SUBTITLE = 'Shows all Jobs related to this contract';
export const CANCEL_LABEL = 'Cancel';
export const SAVE_LABEL = 'Save';

export const CONFIRM_SAVE_LABEL = 'Confirm Save';
export const CONFIRM_SAVE_DIALOG =
  'There are no properties selected in the properties dropdown. No properties will be associated with the contract. Are you sure you wish to continue?';

export const ERROR_LABEL = 'Error';
export const WARNING_LABEL = 'Warning';
export const CONFIRM_CLOSE_WITHOUT_SAVE_DIALOG =
  'Are you sure you want to close without saving? Changes will be lost.';
